import React, { useRef, useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import CART_API from '../../../utilities/api/cart'
import { getCartToken } from '../../../utilities/function/cartToken'
import { getDataFromSuccessResponse, getErrorFromFailResponse } from '../../../utilities/function/apiResponse'
import { appInit, CART_LOADING, updatePopupNotification } from '../../../app/action'

import { withRouter } from 'react-router-dom'
import SolidButton from '../button/solidbutton'

let PromotionForm = (props) => {
  const dispatch = useDispatch()
  const {history} = props
  const codeField = useRef(null)
  const submitCallback = (e) => {
    e.preventDefault()
    const carttoken = getCartToken()
    const code = codeField.current.value
    dispatch({
      type: CART_LOADING
    })
    CART_API.addPromo(code, carttoken).then(successresponse => {
      const data = getDataFromSuccessResponse(successresponse)
      appInit(dispatch, history)
      if (codeField && codeField.current) {
        codeField.current.value = null
      }
      updatePopupNotification(dispatch, {
        status: 'success',
        error: null,
        data
      })
    }, errorresponse => {
      appInit(dispatch, history)
      const error = getErrorFromFailResponse(errorresponse)
      updatePopupNotification(dispatch, {
        status: 'error',
        error,
        data: null
      })
    })
  }

  const [isOpen, setIsOpen] = useState(false)




  const {cartStatus, cartData} = useSelector(state => ({
    cartStatus: state.app.cartStatus,
    cartData: state.app.cartData,
  }))

  const getCouponList = useCallback(() => {
    if (cartStatus === 'success' && cartData && cartData.promos && cartData.promos.length > 0) {
      const list = []
      const {promos} = cartData
      promos.forEach(item => {
        const {code} = item
        if (code) {
          list.push(code)
        }
      })
      return [...new Set(list)]
    }

    return null
  }, [cartStatus, cartData])

  useEffect(()=>{
    if(getCouponList() && getCouponList().length > 0){
      setIsOpen(true)
    }
  },[getCouponList])

  const deletePromo = (code) => {
    const carttoken = getCartToken()
    dispatch({
      type: CART_LOADING
    })
    CART_API.removePromo(code, carttoken).then(successresponse => {
      const data = getDataFromSuccessResponse(successresponse)
      appInit(dispatch, history)
      updatePopupNotification(dispatch, {
        status: 'success',
        error: null,
        data
      })
    }, errorresponse => {
      appInit(dispatch, history)
      const error = getErrorFromFailResponse(errorresponse)
      updatePopupNotification(dispatch, {
        status: 'error',
        error,
        data: null
      })
    })
  }
  const renderForm = () => {
    if (isOpen) {
      const renderCouponList = () => {
        const list = getCouponList()
        if (list && list.length) {
          const renderList = () => {
            const hoverIn = (e) => {
              const el = e.currentTarget
              if(el.classList.contains('status-background-3-10')){
                el.classList.remove('status-background-3-10')
              }
              if(!el.classList.contains('status-background-3-10')){
                el.classList.add('status-background-3-25')
              }
            }
            const hoverOut = (e) => {
              const el = e.currentTarget
              if(el.classList.contains('status-background-3-25')){
                el.classList.remove('status-background-3-25')
              }
              if(!el.classList.contains('status-background-3-10')){
                el.classList.add('status-background-3-10')
              }
            }
            return list.map((code, index) => {
              return (
                <li key={index} className={'status-background-3-10'} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                  <span className={'text status-font-3-100'}>{code}</span><i className={'icon icon-of-x status-font-3-100'}
                                                           onClick={() => {deletePromo(code)}}/>
                </li>
              )
            })
          }
          return (
            <ul className={'of-promotion-form__list clearfix'}>
              {renderList()}
            </ul>
          )
        }
        return (<></>)
      }
      return (
        <>
          {renderCouponList()}
          <form className={`of-promotion-form__form`} onSubmit={submitCallback}>
            <input type={'text'} ref={codeField} placeholder={'Enter your coupon code here'} className={'lines-border-1-100 of-promotion-form__textfield'}/>
            <SolidButton type={'submit'} className={'of-promotion-form__button'}>Apply</SolidButton>
          </form>
        </>
      )
    }
    return (<></>)
  }
  const toggleOnClick = () => {
    setIsOpen(!isOpen)
  }
  const renderToggleText = () => {
    return isOpen ? 'Close' : 'Add'
  }
  return (
    <div className={`of-promotion-form lines-border-1-100`}>
      <div className={'of-promotion-form__top'}>
        <div className={'of-promotion-form__heading text-font-3-100'}>Have a coupon code?</div>
        <button className={'of-promotion-form__toggle'} onClick={toggleOnClick}>
          <span className={'text primary-font-1-100'}>{renderToggleText()}</span><span
          className={'icon primary-font-1-100'}>{isOpen ? '' : '+'}</span>
        </button>
      </div>
      {renderForm()}
    </div>
  )
}

PromotionForm.propTypes = {
  history: PropTypes.any
}

PromotionForm = withRouter(PromotionForm)

export default PromotionForm